import React from "react";

const ThankYouModal = ({ modal, toggleModal }) => {
  if (modal) {
    document.body.classList.add("active-modal");
  } else {
    document.body.classList.remove("active-modal");
  }

  return (
    <>
      {modal && (
        <div className="modal w-screen h-screen fixed	top-0 left-0 right-0 bottom-0 overflow-hidden">
          <div onClick={toggleModal} className="overlay w-screen h-screen fixed	top-0 left-0 right-0 bottom-0 overflow-hidden bg-[rgba_49_49_49_0.8]" />
          <div className=" relative full-screen bg-white my-10 mx-auto border border-solid border-[#888888] w-full max-w-[800px] pt-[30px] pb-[45px] px-[45px] rounded-[32px]"> 
            <button className="absolute top-0 right-0 m-4 w-[45px]" onClick={toggleModal}>
              <img src="https://glocify.com/images/cross-icon.png" alt="cross-icon" />
            </button>  
            <div>
              <img src="https://glocify.com/images/glocify-seo-logo.png" alt="glocify-seo-logo" className="w-full max-w-[150px] block mx-auto" /> 
              <img src="https://glocify.com/images/thank-u.png" alt="thank-u" className="w-full max-w-[350px] block mx-auto mt-[30px]"/> 
              <p className="text-sm font-normal max-w-[450px] block text-center mx-auto my-[25px]">Thank you for reaching out. Our SEO expert will be in touch with you shortly. We appreciate your patience.</p> 
            </div>          
          </div>
        </div>
      )}
    </>
  );
};

export default ThankYouModal;
